import FlushController from 'src/internal/common/FlushController';

import type {FlushSignal} from 'src/internal/common/FlushController';

/**
 * Creates a browser-specific flush signal.
 *
 * In browser environments, dispatches flush when the page becomes hidden.
 * In non-browser environments (React Native, etc.), still returns a valid
 * signal that can be triggered externally via FlushController.
 */
export default function createBrowserFlushSignal(): FlushSignal {
  const controller = new FlushController();

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        controller.flush();
      }
    });
  }

  return controller.signal;
}
